import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';

import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

import { FlexLayoutModule } from '@angular/flex-layout';
import { BaseModule, NotificationModule } from '@seepex/ng-base';
import { DialogModule } from '@seepex/ng-base';
import { FormatUnitNumberDirective } from './directives/format-unit-number.directive';
import { EnterToTabDirective } from './directives/enter-to-tab.directive';
import { NumericDirective } from './directives/numeric.directive';

@NgModule({
  declarations: [FormatUnitNumberDirective, EnterToTabDirective, NumericDirective],
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatCheckboxModule,
    FlexLayoutModule,
    BaseModule,
    DialogModule,
    NotificationModule,
    MatSnackBarModule,
  ],
  exports: [
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatCheckboxModule,
    FlexLayoutModule,
    BaseModule,
    DialogModule,
    MatSnackBarModule,
    FormatUnitNumberDirective,
    EnterToTabDirective,
    NumericDirective,
    NotificationModule,
  ],
  providers: [DecimalPipe],
})
export class SharedModule {}
